/* eslint-disable no-unused-vars */
import React from 'react';
import { PageWrapStyles } from './pagewrapstyles';

export default function PageWrap() {
  function getHTML() {
    if (window.innerWidth < 600) {
      return (
        <iframe
          title="Plugshare map"
          src="https://www.plugshare.com/widget2.html?latitude=-25&longitude=134&spanLat=50&spanLng=50&plugs=1,2,3,4,5,6,42,13,7,8,9,10,11,12,14,15,16,17"
          width="100%"
          height="400"
          allow="geolocation"
        />
      );
    }
    return (
      <iframe
        title="Plugshare map"
        src="https://www.plugshare.com/widget2.html?latitude=-25&longitude=134&spanLat=30&spanLng=40&plugs=1,2,3,4,5,6,42,13,7,8,9,10,11,12,14,15,16,17"
        width="100%"
        height="600"
        allow="geolocation"
      />
    );
  }
  return (
    <PageWrapStyles>
      <h2 className="headline">Australia&apos;s EV charging stations</h2>
      {getHTML()}
      <div className="source">Map courtesy of PlugShare</div>
    </PageWrapStyles>
  );
}
